/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Upload as AntdUpload } from 'antd';

import { NO_MARGIN_BOTTOM } from '@constants';
import { MEDIA_TYPE } from '@api/media/constants';
import * as mediaUtils from '@utils/media';

import Button from '../Button';
import Typography from '../Typography';

import s from './styles.module.less';

const useBeforeUpload = ({ onChange, beforeUpload }) =>
  React.useCallback(
    (_file) => {
      if (mediaUtils.getType(_file) === MEDIA_TYPE.IMAGE) {
        const url = URL.createObjectURL(_file);
        _file.imageUrl = url;
      }

      // eslint-disable-next-line no-unused-expressions
      beforeUpload?.(_file);
      // eslint-disable-next-line no-unused-expressions
      onChange?.(_file);
      return false;
    },
    [onChange, beforeUpload],
  );

const UploadButton = ({ onChange, beforeUpload, children = 'BROWSE', ...props }) => {
  const handleBeforeUpload = useBeforeUpload({ onChange, beforeUpload });

  return (
    <AntdUpload showUploadList={false} beforeUpload={handleBeforeUpload} {...props}>
      <Button type="customBlue">{children}</Button>
    </AntdUpload>
  );
};

const UploadArea = ({ label = 'Drop a file to upload', onChange, beforeUpload, ...props }) => {
  const handleBeforeUpload = useBeforeUpload({ onChange, beforeUpload });

  return (
    <AntdUpload.Dragger className={s.uploadRegion} showUploadList={false} {...props} beforeUpload={handleBeforeUpload}>
      <Typography.Title level={3} style={NO_MARGIN_BOTTOM}>
        {label}
      </Typography.Title>
    </AntdUpload.Dragger>
  );
};

const Upload = () => {
  throw new Error('<Upload> is not meant to be used as a component. Use <Upload.Button> or <Upload.Area>');
};

Upload.Button = UploadButton;
Upload.Area = UploadArea;

export default Upload;
